// extracted by mini-css-extract-plugin
export default {"star":"styles_star__Hq7Tf","starFade":"styles_starFade__s9Uwm"};